module.exports = __webpack_public_path__ + "static/media/EmptyBox.58b69ba1.svg";